export const DAILY_PRAYER_ORDER = ['fajr', 'dhuhr', 'asr', 'maghrib', 'isha'];

export const DAILY_PRAYER_LABELS = {
  fajr: 'Fajr',
  dhuhr: 'Dhuhr',
  asr: 'Asr',
  maghrib: 'Maghrib',
  isha: 'Isha',
};

export const emptyPrayerTimingsBoard = () => ({
  jummah: [],
  daily: DAILY_PRAYER_ORDER.reduce((acc, key) => {
    acc[key] = { azaan: '', jamaat: '' };
    return acc;
  }, {}),
});

export const normalizePrayerTimingsBoard = (raw) => {
  const base = emptyPrayerTimingsBoard();
  if (!raw || typeof raw !== 'object') {
    return base;
  }

  const jummah = Array.isArray(raw.jummah) ? raw.jummah : [];
  base.jummah = jummah.map((row) => ({
    azaan: String(row?.azaan ?? '').trim(),
    jamaat: String(row?.jamaat ?? '').trim(),
    note: String(row?.note ?? '').trim(),
  }));

  const daily = raw.daily && typeof raw.daily === 'object' ? raw.daily : {};
  DAILY_PRAYER_ORDER.forEach((key) => {
    const slot = daily[key] || {};
    base.daily[key] = {
      azaan: String(slot.azaan ?? '').trim(),
      jamaat: String(slot.jamaat ?? '').trim(),
    };
  });

  return base;
};

export const boardHasTimings = (board) => {
  const normalized = normalizePrayerTimingsBoard(board);
  const hasJummah = normalized.jummah.some(
    (row) => row.azaan || row.jamaat || row.note,
  );
  if (hasJummah) return true;
  return DAILY_PRAYER_ORDER.some((key) => {
    const slot = normalized.daily[key];
    return slot?.azaan || slot?.jamaat;
  });
};

export const formatTimeCell = (value) => {
  const text = String(value ?? '').trim();
  return text || '—';
};
